var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIndicatorIcon = function SvgInfoIndicatorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.6 15.2h-.533c-.59 0-1.067-.477-1.067-1.066v-2.667a.533.533 0 0 0-.533-.533h-.534M11.734 8.267a.267.267 0 1 0 0 .533.267.267 0 0 0 0-.533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16",
    clipRule: "evenodd"
  })));
};
export { SvgInfoIndicatorIcon as ReactComponent };
export default __webpack_public_path__ + "4aaf8cd47d7a73adc5d308f200886d2c.svg";